import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { selectAcceptDeclineDisabledState } from '../../../redux/communities/selectors/currentCommunity';
import { actions as declineInvitation } from '../../../redux/communities/declineInvitation';
import { actions as acceptInvitation } from '../../../redux/communities/acceptInvitation';
import Button from '../../Button';
import { COMMUNITY_BTN_ACTIONS } from '../../../constants';

const InviteBtnImpl = ({
  intl: { formatMessage },
  acceptInvite,
  declineInvite,
  invitationId: id,
  disabled,
}) => {
  const handleAccept = useCallback(() => {
    acceptInvite({ id, actionType: COMMUNITY_BTN_ACTIONS.ACCEPT });
  }, [id]);

  const handleDecline = useCallback(() => {
    declineInvite({ id, actionType: COMMUNITY_BTN_ACTIONS.DECLINE });
  }, [id]);

  return (
    <div>
      <Button
        color="primary"
        raised
        type="button"
        onClick={handleAccept}
        disabled={disabled}
      >
        {formatMessage({ id: 'common.accept' })}
      </Button>
      <Button
        raised
        type="button"
        className="ml2"
        disabled={disabled}
        onClick={handleDecline}
      >
        {formatMessage({ id: 'common.decline' })}
      </Button>
    </div>
  );
};

const mapStateToProps = state => ({
  disabled: selectAcceptDeclineDisabledState(state),
});
const mapDispatchToProps = {
  acceptInvite: acceptInvitation.send,
  declineInvite: declineInvitation.send,
};

export const InviteBtn = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(InviteBtnImpl);

const propTypes = {
  invitationId: PropTypes.number.isRequired,
};
InviteBtnImpl.propTypes = {
  ...propTypes,
  intl: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  acceptInvite: PropTypes.func.isRequired,
  declineInvite: PropTypes.func.isRequired,
};

InviteBtn.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/Community/NewPost/InviteBtns.jsx